import {defineStore} from 'pinia'

// @ts-ignore
export const useAdminMembershipStore = defineStore('admin-membership', {
  state: () => ({
    pathPrefix: '/admin/membership'
  }),
  getters: {},
  actions: {
    /**
     * 메인 랜딩페이지 데이터 조회
     * @param payload
     * @returns {Promise<*>}
     */
    async getMainLanding(payload) {
      const {$apiClient} = useNuxtApp()
      let query = ''
      if (payload) {
        query = `?year=${payload}`
      }
      const path = `${this.pathPrefix}/main${query}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    async getMembershipMonthlyInfoList(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/meeting?type=${payload ? payload : ''}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    async postPreSignGreetingImage(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/pre-sign/greeting`
      return await $apiClient(path, {
        method: 'POST',
        body: payload
      })
    },
    async postMembershipMonthlyInfo(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/meeting`
      return await $apiClient(path, {
        method: 'POST',
        body: payload
      })
    },
    async putMembershipMonthlyInfoClose(id, isClosed) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/meeting/close/${id}`
      return await $apiClient(path, {
        method: 'PUT',
        body: {isClosed}
      })
    },
    async postMembershipCompany(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/company`
      return await $apiClient(path, {
        method: 'POST',
        body: payload
      })
    },
    async deleteMembershipCompany(companyId) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/membership/company/${companyId}`
      return await $apiClient(path, {
        method: 'DELETE'
      })
    },
    async putMembershipJoinForm(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/join-form`
      return await $apiClient(path, {
        method: 'PUT',
        body: payload
      })
    },
    async postDataBoard(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/board/data`
      return await $apiClient(path, {
        method: 'POST',
        body: payload
      })
    },
    async postPreSignDataBoard(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/pre-sign/board/data/${payload.id}`
      return await $apiClient(path, {
        method: 'POST',
        body: payload
      })
    },
    async putDataBoard(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/board/data/${payload.id}`
      return await $apiClient(path, {
        method: 'PUT',
        body: payload
      })
    },

    async putMembershipGreeting(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/greeting`
      return await $apiClient(path, {
        method: 'PUT',
        body: payload
      })
    },
    async putMembershipOperation(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/operation`
      return await $apiClient(path, {
        method: 'PUT',
        body: payload
      })
    },
    async postCoordinator(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/coordinator`
      return await $apiClient(path, {
        method: 'POST',
        body: payload
      })
    },
    async postPreSignCoordinatorImage(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/pre-sign/coordinator/${payload.id}`
      return await $apiClient(path, {
        method: 'POST',
        body: payload
      })
    },
    async putCoordinator(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/coordinator/${payload.id}`
      return await $apiClient(path, {
        method: 'PUT',
        body: payload
      })
    },
    async deleteCoordinator(id) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/coordinator/${id}`
      return await $apiClient(path, {
        method: 'DELETE'
      })
    },
    async postPhotoBoard(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/board/photo`
      return await $apiClient(path, {
        method: 'POST',
        body: payload
      })
    },
    async postPreSignPhotoBoard(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/pre-sign/board/photo/${payload.id}`
      return await $apiClient(path, {
        method: 'POST',
        body: payload
      })
    },
    async putPhotoBoard(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/board/photo/${payload.id}`
      return await $apiClient(path, {
        method: 'PUT',
        body: payload
      })
    },
    async deletePreSignPhotoBoard(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/pre-sign/board/photo/${payload.id}/${payload.fileId}`
      return await $apiClient(path, {
        method: 'PATCH',
        body: payload
      })
    },
    async deletePhotoBoard(id) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/board/photo/${id}`
      return await $apiClient(path, {
        method: 'DELETE'
      })
    },
    async deletePreSignDataBoard(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/pre-sign/board/data/${payload.id}`
      return await $apiClient(path, {
        method: 'PATCH',
        body: payload
      })
    },
    async deleteDataBoard(id) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/board/data/${id}`
      return await $apiClient(path, {
        method: 'DELETE'
      })
    },
    async getSubscribePrice(type) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/subscribe/price/${type}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    async putSubscribePrice(priceList) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/subscribe/price`
      return await $apiClient(path, {
        method: 'PUT',
        body: {priceList}
      })
    }
  }
})
